function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AutoFill fields for local, dev and stage
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { acceptCookies, acceptTerms, acceptMarketingConsent, autoClub, confirmEmail, dateOfBirth, dateOfTravel, deliveryMethod, deliveryPickUpStore, email, firstName, image, imageError, imageUploaded, phoneCountryCode, phoneNumber, lastName, licenceAddress, licenceClass, licenceDeliveryAddressLocality, licenceDeliveryAddressPostcode, licenceDeliveryAddressState, licenceDeliveryAddressStreet, licenceAddressLocality, licenceAddressPostcode, licenceAddressState, licenceAddressStreet, licenceExpiry, licenceNumber, membershipNumber, middleName, placeOfBirth, stateOfIssue, title } from '../../actions';
import moment from 'moment';
import { API, COUNTRIES, PHONE_COUNTRY_CODE, AUTO_CLUB, IS_LOCAL, IS_DEV, IS_STAGE, LICENCE_CLASS, OPTIONS, STATES, TITLE, STORES_API } from '../../data/Data';
import { WORDS, RECENT_PHOTO, LICENCE } from '../../data/Mock';
import './AutoFill.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AUTO_RE = new RegExp(/autofill/);
class AutoFill extends React.Component {
  constructor(props) {
    super(props);
    /**
     * Return a random word from our Hipster Ipsum word list
     */
    _defineProperty(this, "randomWord", (capitalise = true, arr = WORDS) => {
      const index = Math.floor(Math.random() * arr.length);
      const word = arr[index];
      const value = capitalise ? `${word.substr(0, 1).toUpperCase()}${word.substr(1)}` : word.toLowerCase();
      return value;
    });
    /**
     * Return a random value from a select drop down value array
     */
    _defineProperty(this, "randomValue", (arr = PHONE_COUNTRY_CODE) => {
      const index = Math.floor(Math.random() * (arr.length - 1)) + 1;
      const {
        value
      } = arr[index];
      return value;
    });
    /**
     * Return a random number of a certain length of digits
     */
    _defineProperty(this, "randomNumber", (length = 10) => {
      const pow = Math.pow(10, length);
      let rand = Math.random();
      switch (true) {
        case rand < 0.001:
          rand = rand * 1000;
          break;
        case rand < 0.01:
          rand = rand * 100;
          break;
        case rand < 0.1:
          rand = rand * 10;
          break;
        default:
        // no op
      }
      return Math.floor(rand * pow);
    });
    /**
     * Return a random number
     */
    _defineProperty(this, "randomDate", (scope = 'future') => {
      const date = moment();
      date.month(Math.floor(Math.random() * 11));
      switch (scope) {
        case 'birth':
          {
            const years = Math.floor(Math.random() * 10) + 19;
            date.subtract(years, 'y').format('YYYY-MM');
            const days = date.daysInMonth();
            date.day(Math.floor(Math.random() * days));
            return date.format('YYYY-MM-DD');
          }

        // future
        default:
          {
            const years = Math.floor(Math.random() * 4) + 1;
            date.add(years, 'y').format('YYYY-MM-DD');
            const days = date.daysInMonth();
            date.day(Math.floor(Math.random() * days));
            return date.format('YYYY-MM-DD');
          }
      }
    });
    /**
     * Return a random club store
     */
    _defineProperty(this, "randomClubStore", () => {
      const {
        application
      } = this.props;
      const clubId = application.club.id;
      return fetch(`${STORES_API}/clubs/${clubId}/stores`).then(response => {
        if (response.status >= 400) {
          const message = `HTTP status code: ${response.status}`;
          const err = new Error(message);
          response.json().then(result => console.warn(result));
          throw err;
        } else {
          return response.json();
        }
      }).then(response => {
        return response.data[Math.floor(Math.random() * response.data.length)];
      }).catch(err => console.error(err));
    });
    /**
     * convert base64 to Blob
     */
    _defineProperty(this, "imageToBlob", (uri, name) => {
      const {
        bugsnagClient
      } = this.props;
      fetch(uri).then(res => res.blob()).then(blob => this.uploadImage(blob, name)).catch(err => {
        bugsnagClient.notify(err);
        imageError(name, true, 'Error uploading image. Could not convert to blob');
      });
    });
    /**
     * Upload image
     */
    _defineProperty(this, "uploadImage", (file, name) => {
      const {
        application
      } = this.props;
      const {
        submission_token
      } = application;
      const {
        id
      } = application;
      const url = `${API}/${id}/images`;
      const type = name === 'recentPhoto' ? 'passport' : name === 'licenceFront' ? 'licence-front' : 'licence-back';
      const formData = new FormData();
      formData.append('file', file, `${name}.jpg`);
      formData.append('type', type);
      formData.append('submission_token', submission_token);

      // fetch sets the right headers when passed a FormData object as `body:`
      // eslint-disable-next-line no-unused-vars
      let {
        headers,
        ...options
      } = OPTIONS;
      options = {
        ...options,
        body: formData
      };
      fetch(url, options).then(response => {
        if (response.status >= 400) {
          const message = `HTTP status code: ${response.status}`;
          const err = new Error(message);
          response.json().then(result => console.warn(result));
          throw err;
        } else {
          return response.json();
        }
      }).then(response => this.apiResponse(response, name)).catch(err => this.apiError(err, null, name));
    });
    /**
     * API response
     *
     * @param {object} response - the API response
     */
    _defineProperty(this, "apiResponse", (response, name) => {
      const {
        imageUploaded
      } = this.props;
      switch (true) {
        case response['errors'] !== undefined:
          {
            // Set a default message.
            let message = 'Sorry, there has been an error uploading your photo';

            // If we have received an error title, use that title for the message.
            if (response['message'] !== undefined) {
              message = response.message;
            }
            const error = new Error(message);
            this.apiError(error, response, name);
            return false;
          }
        default:
          imageUploaded(name, true);
          return true;
      }
    });
    /**
     * API error
     */
    _defineProperty(this, "apiError", (error, response = null, name) => {
      const {
        bugsnagClient
      } = this.props;
      imageUploaded(name, false);
      if (response) {
        error.message = `${error.message}. ${JSON.stringify(response)}`;
      }

      // Send an error report to BugSnag
      bugsnagClient.notify(error);
    });
    _defineProperty(this, "fill", () => {
      // Address (AU only)
      const street = `${this.randomNumber(3)} ${this.randomWord()} St.`;
      const locality = this.randomWord();
      const state = this.randomValue(STATES);
      const postcode = this.randomNumber(4).toFixed(0);
      const address = `${street} ${locality}, ${state}, ${postcode}`;

      // image

      for (let field in this.props) {
        switch (field) {
          case 'acceptCookies':
            this.props[field](true);
            break;
          case 'acceptTerms':
            this.props[field](true);
            break;
          case 'acceptMarketingConsent':
            this.props[field](true);
            break;
          case 'autoClub':
            {
              const value = this.randomValue(AUTO_CLUB);
              this.props[field](value);
              break;
            }
          case 'phoneCountryCode':
            {
              const value = this.randomValue(PHONE_COUNTRY_CODE);
              this.props[field](value);
              break;
            }
          case 'dateOfBirth':
            {
              const value = this.randomDate('birth');
              this.props[field](value);
              break;
            }
          case 'dateOfTravel':
            {
              const value = this.randomDate();
              this.props[field](value);
              break;
            }
          case 'deliveryMethod':
            {
              const {
                setDeliveryPickUpStore
              } = this.props;
              this.randomClubStore().then(clubStore => {
                if (clubStore && clubStore.id) {
                  const value = Math.random() > 0.5 ? 'Postage' : 'PickUpInStore';
                  this.props[field](value);
                  if (value === 'PickUpInStore') {
                    setDeliveryPickUpStore(clubStore.id);
                  }
                } else {
                  this.props[field]('Postage');
                }
              });
              break;
            }
          case 'email':
            {
              const value = `${this.randomWord(false)}@${this.randomWord(false)}.com`;
              this.props[field](value);
              this.props.confirmEmail(value);
              break;
            }
          case 'firstName':
            {
              const value = this.randomWord();
              this.props[field](value);
              break;
            }
          case 'image':
            {
              this.props[field]('recentPhoto', RECENT_PHOTO);
              this.imageToBlob(RECENT_PHOTO, 'recentPhoto');
              this.props[field]('licenceBack', LICENCE);
              this.imageToBlob(LICENCE, 'licenceBack');
              this.props[field]('licenceFront', LICENCE);
              this.imageToBlob(LICENCE, 'licenceFront');
              break;
            }
          case 'phoneNumber':
            {
              const options = [`9${this.randomNumber(7)}`, `0404${this.randomNumber(6)}`];
              const value = options[Math.floor(Math.random() * options.length)];
              this.props[field](value);
              break;
            }
          case 'lastName':
            {
              const value = this.randomWord();
              this.props[field](value);
              break;
            }
          case 'licenceClass':
            {
              const value = this.randomValue(LICENCE_CLASS);
              this.props[field](value);
              break;
            }
          case 'licenceAddress':
            {
              this.props[field](address);
              break;
            }
          case 'licenceAddressLocality':
            {
              this.props[field](locality);
              break;
            }
          case 'licenceAddressPostcode':
            {
              this.props[field](postcode);
              break;
            }
          case 'licenceAddressState':
            {
              this.props[field](state);
              break;
            }
          case 'licenceAddressStreet':
            {
              this.props[field](street);
              break;
            }
          case 'licenceDeliveryAddressLocality':
            {
              this.props[field](locality);
              break;
            }
          case 'licenceDeliveryAddressPostcode':
            {
              this.props[field](postcode);
              break;
            }
          case 'licenceDeliveryAddressState':
            {
              this.props[field](state);
              break;
            }
          case 'licenceDeliveryAddressStreet':
            {
              this.props[field](street);
              break;
            }
          case 'licenceExpiry':
            {
              const value = this.randomDate();
              this.props[field](value);
              break;
            }
          case 'licenceNumber':
            {
              const value = `${this.randomNumber(8)}`;
              this.props[field](value);
              break;
            }
          case 'membershipNumber':
            {
              const value = `${this.randomNumber(8)}`;
              this.props[field](value);
              break;
            }
          case 'middleName':
            {
              const value = this.randomWord();
              this.props[field](value);
              break;
            }
          case 'placeOfBirth':
            {
              const value = this.randomValue(COUNTRIES);
              this.props[field](value);
              break;
            }
          case 'stateOfIssue':
            {
              const value = this.randomValue(STATES);
              this.props[field](value);
              break;
            }
          case 'title':
            {
              const value = this.randomValue(TITLE);
              this.props[field](value);
              break;
            }
          default:
          // no op
        }
      }
    });
    const {
      hostname,
      search
    } = window.location;
    let show = false;
    switch (true) {
      case IS_LOCAL.test(hostname):
      case IS_DEV.test(hostname):
      case IS_STAGE.test(hostname) && AUTO_RE.test(search):
        show = true;
        break;
      default:
      // no op
    }
    this.state = {
      show
    };
  }
  render() {
    const {
      show
    } = this.state;
    if (!show) {
      return null;
    }
    return /*#__PURE__*/_jsxs("div", {
      className: "AutoFill",
      onClick: this.fill,
      tabIndex: "0",
      role: "button",
      title: "Autofill form for testing",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: "pencil",
        className: "left"
      }), "Autofill"]
    });
  }
}
const mapStateToProps = ({
  application,
  images,
  deliveryPickUpStore
}) => {
  return {
    application,
    images,
    deliveryPickUpStore
  };
};
const mapDispatchToProps = dispatch => {
  return {
    acceptCookies: value => {
      dispatch(acceptCookies(value));
    },
    acceptTerms: value => {
      dispatch(acceptTerms(value));
    },
    acceptMarketingConsent: value => {
      dispatch(acceptMarketingConsent(value));
    },
    autoClub: value => {
      dispatch(autoClub(value));
    },
    confirmEmail: value => {
      dispatch(confirmEmail(value));
    },
    phoneCountryCode: value => {
      dispatch(phoneCountryCode(value));
    },
    dateOfBirth: value => {
      dispatch(dateOfBirth(value));
    },
    dateOfTravel: value => {
      dispatch(dateOfTravel(value));
    },
    deliveryMethod: value => {
      dispatch(deliveryMethod(value));
    },
    setDeliveryPickUpStore: value => {
      dispatch(deliveryPickUpStore(value));
    },
    email: value => {
      dispatch(email(value));
    },
    firstName: value => {
      dispatch(firstName(value));
    },
    image: (name, value) => {
      dispatch(image(name, value));
    },
    imageError: (name, error, message) => {
      dispatch(imageError(name, error, message));
    },
    imageUploaded: (name, value) => {
      dispatch(imageUploaded(name, value));
    },
    phoneNumber: value => {
      dispatch(phoneNumber(value));
    },
    lastName: value => {
      dispatch(lastName(value));
    },
    licenceAddress: value => {
      dispatch(licenceAddress(value));
    },
    licenceAddressLocality: value => {
      dispatch(licenceAddressLocality(value));
    },
    licenceAddressPostcode: value => {
      dispatch(licenceAddressPostcode(value));
    },
    licenceAddressState: value => {
      dispatch(licenceAddressState(value));
    },
    licenceAddressStreet: value => {
      dispatch(licenceAddressStreet(value));
    },
    licenceDeliveryAddressLocality: value => {
      dispatch(licenceDeliveryAddressLocality(value));
    },
    licenceDeliveryAddressPostcode: value => {
      dispatch(licenceDeliveryAddressPostcode(value));
    },
    licenceDeliveryAddressState: value => {
      dispatch(licenceDeliveryAddressState(value));
    },
    licenceDeliveryAddressStreet: value => {
      dispatch(licenceDeliveryAddressStreet(value));
    },
    licenceClass: value => {
      dispatch(licenceClass(value));
    },
    licenceExpiry: value => {
      dispatch(licenceExpiry(value));
    },
    licenceNumber: value => {
      dispatch(licenceNumber(value));
    },
    membershipNumber: value => {
      dispatch(membershipNumber(value));
    },
    middleName: value => {
      dispatch(middleName(value));
    },
    placeOfBirth: value => {
      dispatch(placeOfBirth(value));
    },
    stateOfIssue: value => {
      dispatch(stateOfIssue(value));
    },
    title: value => {
      dispatch(title(value));
    }
  };
};
const VisibleAutoFill = connect(mapStateToProps, mapDispatchToProps)(AutoFill);
export default VisibleAutoFill;